import React from 'react'
import styled from 'styled-components'
import Link from 'gatsby-link'

import Sponsors from '../components/sponsors'

const Section = styled.section`
  max-width: 40em;
  h2 + p {
    margin-bottom: 2.5rem;
    text-align: center;
  }
  div {
    margin: 4rem auto;
  }
  svg, img {
    width: 100%;
  }
  svg {
    max-height: 85px;
  }
`;

const SponsorsPage = () => (
    <Section>
      <h2>Sponsors</h2>
      <p>
        Interested in sponsoring Faith Leads Tech? Email{' '}
        <a href="mailto:info@faithleads.tech">info@faithleads.tech</a>.
      </p>
      <Sponsors />
    </Section>
);

export default SponsorsPage



// WEBPACK FOOTER //
// ./src/pages/sponsors.js